<template>
  <div class="details">
    <div class="container_w">
      <bread-crumb :crumbList="crumbList"></bread-crumb>
      <page-header :headerTitle="headerTitle"></page-header>
      <div v-html="detailHtml" class="html_box">
          
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb/BreadCrumb";
import PageHeader from "@/components/PageHeader/PageHeader";
export default {
  components: {
    BreadCrumb,
    PageHeader,
  },
  name: "details",
  data() {
    return {
      crumbList:[
          // {
          //     name:'News',
          //     url:'/news'
          // }
      ],
      headerTitle:'',
      detailHtml:''
    };
  },
  props: {},
  watch: {},
  methods: {},
  filters: {},
  computed: {},
  created() {
    let fileText = this.$route.query.fileText
    console.log(fileText)
    this.headerTitle = this.$route.query.title
    var that = this
    this.$Ajax.get(fileText)
    .then( (response)=> {
        this.detailHtml = response.data
    })
    .catch( (error) =>{
        console.log(error);
    });
  },
  mounted() {},
  destroyed() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="less" scoped>
.details{
    .container_w{
        ul{
            padding-top: 48px;
            padding-bottom: 64px;
            li{
                height:64px;
                border-bottom:1px solid rgba(236,238,240,1);
                padding-top: 22px;
            }
        }
        
    }
}

</style>
